import React from 'react';
import {AccountPool} from 'api';
import {Row} from 'react-table';
import ScoreRankLabel from 'components/ScoreRankLabel';

interface Props {
  row: Row<AccountPool>;
}

const ScoreCell = ({row}: Props) => {
  const accountPool: AccountPool = row.original;
  const score = accountPool.score?.scoreRank;

  return (
    <div className="flex items-center justify-center w-full h-full">
      <ScoreRankLabel scoreRank={score} />
    </div>
  );
};

export default ScoreCell;
